// extracted by mini-css-extract-plugin
export default {"HostServiceList_Root":"HostServiceList_HostServiceList_Root__4jRqF"};